import _ from "lodash";
import store from "../../submit-task/submit-task-store";

export default {
  bus: new Vue({}),
  states: {
    search: '',
    user: null,
    loading_chats: true,
    loading_messages: false,
    chats: [],
    messages: [],
    activeChat: null,
    form: {
      message: '',
      attachments: [],
    },
    typingUsers: [],
    showChatDetails: false,
  },
  getChats() {
    return new Promise(resolve => {
      this.states.loading_chats = true
      axios.get('/api/v2/chat', {
        params: {api_token: this.states.user.api_token}
      })
        .then(resp => this.states.chats = _.keyBy(resp.data.data, 'id'))
        .finally(() => {
          this.states.loading_chats = false;
          resolve()
        })
    })
  },
  selectChat(chat) {
    this.states.messages = []
    this.states.loading_messages = true
    this.leaveChatChannel(this.states.activeChat)
    this.states.activeChat = chat
    chat.read_by = _.uniq([...chat.read_by, this.states.user.id])
    axios.get('/api/v2/chat/' + chat.id + '/message', {
      params: {api_token: this.states.user.api_token}
    })
      .then(resp => {
        this.states.messages = resp.data.data
        this.states.loading_messages = false
        this.joinChatChannel(chat)
        this.scrollToLastMessage()
      })
      .finally(() => this.states.loading_messages = false)
  },
  sendMessage() {
    let form = new FormData()
    form.append('content', this.states.form.message)
    this.states.form.attachments.forEach(attachment => {
      form.append('attachments[]', attachment)
    })
    this.states.form.message = ''
    this.states.form.attachments = []
    axios({
      method: 'post',
      url: '/api/v2/chat/' + this.states.activeChat.id + '/message',
      data: form,
      params: {api_token: this.states.user.api_token},
      headers: {'Content-Type': 'multipart/form-data'}
    })
      .then(resp => {
        this.states.messages.push(resp.data.data)
        this.scrollToLastMessage()
        this.readChat(this.states.activeChat)
      })
      .catch(err => {
        console.log(err)
        if (err.response && err.response.status === 422) {
          _.forEach(err.response.data.errors, errors => {
            Vue.$toast.error(errors[0]);
          })
        }
      })
  },
  scrollToLastMessage() {
    this.bus.$emit('scroll-to-last-message')
  },
  joinUserChannel() {
    Echo.private('user.' + this.states.user.id)
      .listen('ChatUpdated', e => {
        console.log('chat updated', e)
        Vue.set(this.states.chats, e.chat.id, e.chat)
      })
      .listen('ChatCreated', e => {
        Vue.set(this.states.chats, e.chat.id, e.chat)
      })
  },
  joinChatChannel(chat) {
    Echo.join('chat.' + chat.id)
      .listen('MessageSent', e => {
        if (this.states.activeChat.id === chat.id) {
          this.states.messages.push(e.message)
          this.scrollToLastMessage()
          this.readChat(chat)
        }
      })
    Echo.private('chat.' + chat.id)
      .listenForWhisper('typing', user => {
        !this.states.typingUsers.find(typingUser => typingUser.user.id === user.id)
        && this.states.typingUsers.push({
          user: user,
          clearAt: Date.now() + 5000
        })
      })
  },
  leaveChatChannel(chat) {
    chat !== null && Echo.leave('chat.' + chat.id)
  },
  leaveUserChannel() {
    Echo.leave('user.' + this.states.user.id)
  },
  readChat(chat) {
    axios.get('/api/v2/chat/' + chat.id + '/read', {
      params: {api_token: this.states.user.api_token},
    })
  },
  broadcastTyping() {
    Echo.private('chat.' + this.states.activeChat.id)
      .whisper('typing', this.states.user)
  },
  registerTypingIntervals() {
    this.typingUsersInterval = setInterval(() => {
      _.forEach(this.states.typingUsers, (typingUser, index) => {
        if (typingUser.clearAt < Date.now()) {
          this.states.typingUsers.splice(index, 1)
        }
      })
    }, 1000)
  },
  addAttachment(event) {
    let files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      this.states.form.attachments.push(files.item(i))
    }
  },
  removeAttachment(index) {
    Vue.delete(this.states.form.attachments, index)
  },
  joinInitialChat() {
    let urlParams = new URLSearchParams(window.location.search);
    let chatId = urlParams.get('chat');
    let chat = _.find(this.states.chats, chat => chat.id + '' === chatId + '')
    chat !== undefined && this.selectChat(chat)
  }
}
